<template lang="pug">
  header
    .wrap2
      h2 Presentado por
        img(:src="`${baseUrl}assets/images/logo-engie.svg`", alt="Engie")
      transition(name="bottom-fade" mode="out-in")
        h1(v-if="$route.name !== 'home'")
          img(:src="`${baseUrl}assets/images/logo-lollapalooza.svg`", alt="Lollapalooza Chile")
</template>
<script>
  export default  {
    data () {
      return {
        baseUrl: process.env.BASE_URL
      }
    }
  }
</script>
<style lang="scss" scoped>
.wrap2{
  min-width: 280px;
}
header{
  display: flex;
  align-items: center;
  justify-content: center;
  h2{
    padding: 0.5rem;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    img{
      max-height: 40px;
      margin-left: 0.5rem;
    }
  }
  h1{
    text-align: center;
    img{
      max-height: 310px;
      max-width: 100%;
    }
  }
}
</style>

